class TaskCollection extends App.Collections.BaseCollection {
    url = 'Task';
    model = App.Models.Task;
}

App.Collections.Tasks = TaskCollection;
